import AvatarNotificationContainer from './AvatarNotificationContainer';

export default AvatarNotificationContainer;